const MovieGenreDetail = [
  {
    name: "Comédies, films d'animation",
    movie_genres_ids: [16, 10751, 35],
    tv_genres_ids: [16, 10751, 35],
  },
  {
    name: 'dessins animés',
    movie_genres_ids: [],
    tv_genres_ids: [10762],
  },
  {
    name: 'Horreur',
    movie_genres_ids: [27],
    tv_genres_ids: [],
  },
  {
    name: 'Amour',
    movie_genres_ids: [10749],
    tv_genres_ids: [],
  },
  {
    name: 'Policier, suspense',
    movie_genres_ids: [53, 9648, 80],
    tv_genres_ids: [80],
  },
  {
    name: 'Fantastique, Science-fiction, Action',
    movie_genres_ids: [878, 14, 12, 28],
    tv_genres_ids: [10765, 12, 10759],
  },
  {
    name: 'Guerre, histoire',
    movie_genres_ids: [10752, 36],
    tv_genres_ids: [10768],
  },
  {
    name: 'Western',
    movie_genres_ids: [37],
    tv_genres_ids: [37],
  },
];

export default MovieGenreDetail;
